import styled from "styled-components";

export const Global = styled.html`
   padding: 0;
   margin: 0;
   box-sizing: border-box;
   background: black;
`;